import cn from 'classnames';
import { array, func, number, object, oneOfType, string } from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  Button,
  PopoverBody,
  PopoverHeader,
  UncontrolledCollapse,
  UncontrolledPopover,
} from 'reactstrap';
import { STATIC_PATH } from '../../config';
import { FMessage } from '../../hoc/IntlComponents';
import { currencyToSign, getStoreUrl } from '../../utils/utils';
import CustomTable from '../CustomTable/CustomTable';

class OffersListItem extends Component {
  static propTypes = {
    id: number.isRequired,
    title: string.isRequired,
    stats: array.isRequired,
    modifies: object.isRequired,
    short_pixels: object.isRequired,
    pixels: oneOfType([object, array]).isRequired,
    geo: array.isRequired,
    images: object.isRequired,
    offerSettings: object,
    countriesList: array,
    onRequestOfferAccess: func,
    scrollPosition: object,
    onFlowCreate: func.isRequired,
    globalCurrencies: array.isRequired,
    onUnavailableOfferClick: func.isRequired,
  };

  static defaultProps = {
    countriesList: [],
    forbiddenGeo: [],
    LIMIT: 3,
  };

  state = {
    popoverOpen: false,
    popoverTarget: '',
    showAll: {},
  };

  toggle = (id) => {
    this.setState((prevState) => ({
      popoverOpen: !prevState.popoverOpen,
      popoverTarget: id,
    }));
  };

  closePopover = () => {
    this.setState(() => ({
      popoverOpen: false,
      popoverTarget: '',
    }));
  };

  getStats = (stat, isNew, sign) =>
    isNew ? 'NEW' : stat > 0 ? `${stat} ${currencyToSign(sign)}` : '—';

  getOfferStats = (stats = [], type, period, sign) => {
    const stat = stats.find((stat) => stat.period === period);
    return this.getStats(stat[type], stat.new, sign);
  };

  renderCoinTooltip = ({ id, target, coins }) => {
    return (
      <UncontrolledPopover
        trigger="hover"
        className="offer-coins-popover"
        placement="left"
        target={`${target}-${id}`}
      >
        <PopoverHeader>
          {' '}
          <b>
            <FMessage id="offer.tooltip.header" />
          </b>
        </PopoverHeader>
        <PopoverBody>
          {' '}
          <div>
            <FormattedMessage
              id="offer.tooltip.p"
              defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
              values={{
                coins,
              }}
            />
            <a href={getStoreUrl()} target="_blank">
              <FMessage id="offer.tooltip.link-to-store" />
            </a>
          </div>
        </PopoverBody>
      </UncontrolledPopover>
    );
  };

  renderCoins = () => {
    const {
      modifies: { coins },
      id,
    } = this.props;
    if (coins === 1) {
      return (
        <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </div>
      );
    } else if (coins === 2) {
      return (
        <Link to="/offers/double" id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </Link>
      );
    }
    return null;
  };

  getOfferImgSrc = () => {
    const { images, offerSettings } = this.props;
    if (
      (!images || (images && !images[100])) &&
      (!offerSettings || (offerSettings && !offerSettings['images_path']))
    ) {
      return null;
    } else {
      return `${offerSettings['images_path']}${images[100]}`;
    }
  };

  sortPixelsBySumm = (a, b) => {
    if (a.isPercent && b.isPercent) return parseInt(b.summ, 10) - parseInt(a.summ, 10);
    else if (a.isPercent && !b.isPercent) return -1;
    else if (!a.isPercent && b.isPercent) return 1;
    else return b.summ - a.summ;
  };

  sortPixelsBySummGM = (a, b) => {
    // 0 -> % -> desc
    if (a.summ === 0) return -1;
    else if (b.summ === 0) return 1;
    else if (a.summ === b.summ) return 0;
    else if (a.isPercent && b.isPercent) return parseInt(b.summ, 10) - parseInt(a.summ, 10);
    else if (a.isPercent && !b.isPercent) return -1;
    else if (!a.isPercent && b.isPercent) return 1;
    else return b.summ - a.summ;
  };

  getPayout = (p) => {
    return p.text_summ
      ? p.text_summ
      : `${p.summ} ${p.isPercent ? '%' : currencyToSign(p.currency)}`;
  };

  getPrice = (geo) => {
    const { offer_geo } = this.props;
    if (!offer_geo.prices[geo]) return '';
    return `${offer_geo.prices[geo].price} ${offer_geo.prices[geo].currency}`;
  };

  getCountryTitle = (geo) => {
    // Оффер ограничен теми странами что указаны в поле geo=["RU", "GB"]. Если у pixel geo="",
    // то значит эта цель для всх стран.
    // Если у оффера goe = [] - Весь Мир.
    // По инициативе вебмастеров, если у pixel geo="", будем считать что это весь мир
    const { countries } = this.props;
    if (!geo) return <FormattedMessage id="offer.geo-list.all" defaultMessage="The whole world" />;
    return (Array.isArray(countries) && countries.find((c) => c.id === geo)?.title) || geo;
  };

  handleShowList = () => {
    const { id } = this.props;
    this.setState({
      showAll: { ...this.state.showAll, [`offer-${id}`]: !this.state.showAll[`offer-${id}`] },
    });
  };

  renderButton = () => {
    const { id } = this.props;
    const { showAll } = this.state;
    return (
      <span
        className="btn-show-list"
        role="button"
        id={`offer-${id}`}
        onClick={this.handleShowList}
      >
        {showAll[`offer-${id}`] ? (
          <FormattedMessage id="offers.table.btn-show-off" defaultMessage="Hide" />
        ) : (
          <FormattedMessage id="offers.table.btn-show-on" defaultMessage="Show all" />
        )}
      </span>
    );
  };

  checkIsConfirmedDecline = (pixel) =>
    pixel.group_name === 'Подтверждение отмены' || pixel.group_name === 'Confirmed decline';

  renderPixelItems = () => {
    const { pixels, id, similarGmOffers, offer_geo, LIMIT } = this.props;
    const PRODUCT_OFFER = offer_geo.prices && !Array.isArray(offer_geo.prices);

    if (PRODUCT_OFFER) {
      // const sortPixels = [...pixels.sort(this.sortPixelsBySumm)]
      const hasConfirmedDeclinePixel = pixels.some((p) => this.checkIsConfirmedDecline(p));
      if (hasConfirmedDeclinePixel) {
        // declines to bottom
        pixels.sort((a, b) =>
          this.checkIsConfirmedDecline(a) && !this.checkIsConfirmedDecline(b)
            ? 1
            : !this.checkIsConfirmedDecline(a) && this.checkIsConfirmedDecline(b)
            ? -1
            : 0,
        );
      }
      const mapPixels = pixels.map((p) => {
        return (
          <div className="grid-custom-layout" key={p.id}>
            {/* <div className="geo">{this.getCountryTitle(p.geo)}</div> */}
            {/* <div className="price">{this.getPrice(p.geo)}</div> */}
            <div className="rate pr-3">{this.getPayout(p)}</div>
          </div>
        );
      });
      return (
        <div className="offer-pixel-cell">
          <div className="target pr-3">
            {/* ищем название основоной цели (на случай если отмена будет первой в массиве) */}
            {pixels.length > 0 &&
              (pixels.find((p) => !this.checkIsConfirmedDecline(p))?.group_name ||
                pixels[0].group_name)}
            {hasConfirmedDeclinePixel ? (
              <div>
                <span id={`offer-pixels-conf-reject-${id}`}>
                  <i className="icon-cross-rounded offer-pixels-conf-reject-icon offer-pixels-conf-reject-icon--gray" />
                  <i className="icon-check-rounded offer-pixels-conf-reject-icon offer-pixels-conf-reject-icon--green" />
                </span>
              </div>
            ) : null}
          </div>
          <div className="d-flex flex-column prices">
            {mapPixels.slice(0, LIMIT)}
            {mapPixels.length > LIMIT && (
              <div>
                {/* <UncontrolledCollapse toggler={`#offer-${id}`}>
                  {mapPixels.slice(LIMIT)}
                </UncontrolledCollapse> */}
                {this.renderButton()}
              </div>
            )}
          </div>
          {hasConfirmedDeclinePixel ? (
            <UncontrolledPopover target={`offer-pixels-conf-reject-${id}`} trigger="hover">
              <PopoverHeader>
                <FMessage id="offer.tooltip-decline.header" />
              </PopoverHeader>
              <PopoverBody>
                <FMessage id="offer.tooltip-decline.text" />
              </PopoverBody>
            </UncontrolledPopover>
          ) : null}
        </div>
      );
    } else {
      // не товарные офферы (финансы, геблинг и тд)
      const mapPixels = [];
      const sortPixels = [...pixels].sort(this.sortPixelsBySummGM);
      sortPixels.forEach((p) => {
        mapPixels.push(
          <div className="offer-pixel-cell" key={p.id}>
            <div className="target pr-3">{p.group_name || p.title}</div>
            <div className={`prices ${similarGmOffers && 'prices--w50'} grid-custom-layout`}>
              {/* <div className="geo">{this.getCountryTitle(p.geo)}</div> */}
              {/* {!similarGmOffers && <div className="price"></div>} */}
              <div className="rate pr-3">{this.getPayout(p)}</div>
            </div>
          </div>,
        );
      });
      return (
        <>
          {mapPixels.slice(0, LIMIT)}
          {/* {mapPixels.length > LIMIT && (
            <UncontrolledCollapse toggler={`offer-${id}`}>
              {mapPixels.slice(LIMIT)}
            </UncontrolledCollapse>
          )} */}
          {mapPixels.length > LIMIT && (
            <div className="offer-pixel-cell">
              <div className="target pr-3"></div>
              <div className={`prices ${similarGmOffers && 'prices--w50'}`}>
                {/* <div className="geo">{this.renderButton()}</div>
                {!similarGmOffers && <div className="price"></div>} */}
                <div className="rate pr-3"></div>
              </div>
            </div>
          )}
        </>
      );
    }
  };

  render() {
    const {
      id,
      title,
      stats,
      modifies,
      onRequestOfferAccess,
      onFlowCreate,
      globalCurrencies,
      similarGmOffers,
      admit,
      onUnavailableOfferClick,
      categories,
    } = this.props;
    const [baseCurrency] = globalCurrencies;
    const isHidden = modifies.is_private || modifies.no_access || modifies.is_available === false;
    return (
      <CustomTable.Row className="offers-list-item">
        {/* <CustomTable.Cell>
          <div className="offer-pic">
            <img className="img-fluid rounded-circle" src={`${this.getOfferImgSrc()}?1`} alt="" />
            {this.renderCoins()}
          </div>
        </CustomTable.Cell> */}

        <CustomTable.Cell>
          {!modifies.is_available ? (
            <a href="" onClick={onUnavailableOfferClick}>
              {title}
            </a>
          ) : modifies.is_private ? (
            <span>{title}</span>
          ) : (
            <Link
              className="offer-title"
              to={
                modifies.no_access
                  ? `/tickets/create?theme=getPrivateOffers&offer=${id}`
                  : `/offers/${id}`
              }
            >
              {title}
            </Link>
          )}
          <div className="badges">
            {modifies.exclusive && <span className="badge badge-danger mr-1">exclusive</span>}
            {modifies.is_new && <span className="badge badge-success mr-1">new</span>}
            {admit.private && <span className="badge badge-private">private</span>}
            {Array.isArray(categories) && categories.includes(100) && (
              <span className="badge badge-tiktok">TikTok</span>
            )}
          </div>
        </CustomTable.Cell>

        <CustomTable.Cell className={cn({ blur: isHidden, 'hidden-text': isHidden })}>
          {this.renderPixelItems()}
        </CustomTable.Cell>

        {!similarGmOffers && (
          <CustomTable.Cell
            className={cn({ blur: isHidden, 'hidden-text': isHidden }, 'text-left', 'min-w-unset')}
          >
            {/* на офферах категории гемблинг стата CR и EPC не должна показываться, OFFERRUM-1170 */}
            {!modifies.g ? this.getOfferStats(stats, 'rate', 'week', '%') : '—'}
          </CustomTable.Cell>
        )}

        {!similarGmOffers && (
          <CustomTable.Cell
            className={cn({ blur: isHidden, 'hidden-text': isHidden }, 'text-left', 'min-w-unset')}
          >
            {/* на офферах категории гемблинг стата CR и EPC не должна показываться, OFFERRUM-1170 */}
            {!modifies.g ? this.getOfferStats(stats, 'cr', 'week', '%') : '—'}
          </CustomTable.Cell>
        )}

        {!similarGmOffers && (
          <CustomTable.Cell
            className={cn({ blur: isHidden, 'hidden-text': isHidden }, 'text-left', 'min-w-unset')}
          >
            {!modifies.g ? this.getOfferStats(stats, 'epc', 'week', baseCurrency) : '—'}
          </CustomTable.Cell>
        )}

        <CustomTable.Cell className="text-left action">
          {modifies.is_my ? (
            <Button color="primary" size="sm" onClick={onFlowCreate.bind(null, id)} outline>
              <FormattedMessage id="offer.buttons.create-flow" defaultMessage="Create flow" />
            </Button>
          ) : modifies.is_private ? (
            <div className="private-access-text">
              <i className="icon-lock" />{' '}
              <span>
                <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
              </span>
            </div>
          ) : modifies.no_access ? (
            <Button
              tag={Link}
              color="primary"
              size="sm"
              to={`/tickets/create?theme=getPrivateOffers&offer=${id}`}
            >
              <FormattedMessage id="offer.buttons.get-access" defaultMessage="Get access" />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              size="sm"
              onClick={() => onRequestOfferAccess(id, title)}
            >
              <FormattedMessage id="offer.buttons.activate-offer" defaultMessage="Activate" />
            </Button>
          )}
        </CustomTable.Cell>
        {modifies.no_access && (
          <div className="private-access">
            <i className="icon-lock" />{' '}
            <span>
              <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
            </span>
          </div>
        )}
      </CustomTable.Row>
    );
  }
}

export default OffersListItem;
